const actions = {
  SET_STATE: 'wootransactions/SET_STATE',
  GET_TRANSACTION_LOG: 'wootransactions/GET_TRANSACTION_LOG',
}

export default actions
